import { render, staticRenderFns } from "./TenantAddress.vue?vue&type=template&id=2e8647c3&"
import script from "./TenantAddress.vue?vue&type=script&lang=js&"
export * from "./TenantAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports